module.exports = __webpack_public_path__ + "img/pic11.7e6a565a.png";